import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.user.edit.config.isLoading;
}

export default editIsLoading;
